<span>
  <app-profile-photo
    [user]="user"
    [isClickEnabled]="isClickEnabled"
    [showName]="showName"
    [fontSize]="fontSize"
    [width]="width"
    [showYouWord]="showYouWord"
    [userStatus]="
      foregroundInactivityObservable && (foregroundInactivityObservable | async)
        ? undefined
        : userStatus
    "
  ></app-profile-photo>

  <svg-icon
    *ngIf="enableInactivityIndicator"
    [hidden]="
      !isUserInCall ||
      !foregroundInactivityObservable ||
      (foregroundInactivityObservable | async) !== true
    "
    [ngClass]="{ 'svg-small': small, 'with-name': showName }"
    [icon]="'inactive_indicator_with_white_BG'"
    [appTooltipDisabled]="!enableTooltips || (tooltip$ | async) === ''"
    [appTooltip]="tooltip$ | async"
    [appTooltipPlacement]="'bottom-center'"
    [appTooltipArrow]="'top'"
  ></svg-icon>
</span>
